<template>
  <v-container fluid class="pa-0">
    <v-expansion-panels class="w-form" v-model="openedPanel" accordion>
      <v-expansion-panel>
        <!-- <v-expansion-panel-header class="tit-lev1">
          Div: [{{ division }}]- Ship: [{{ ship }}] {{ cboDivCd === '1' ? '' : `- [${frmDate} ~ ${toDate}]` }}
        </v-expansion-panel-header> -->
        <v-expansion-panel-header class="tit-lev1">
          {{ panelHeaderText }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-expansion-panels v-model="cOpenedPanel" accordion>
            <!-- Division -->
            <v-expansion-panel>
              <v-expansion-panel-header>Division: {{ division }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-select label="Select" v-model="cboDivCd" :items="listDivCd" :item-value="`code`" :item-text="`name`" ></v-select>
              </v-expansion-panel-content>
            </v-expansion-panel>          
            <!-- Ship No -->
            <v-expansion-panel>
              <v-expansion-panel-header>Ship No: {{ ship }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <v-select label="Select" v-model="cboShipNo" :items="listShip" :item-value="`shipNo`" :item-text="`shipNo`" @change = "btnSearch()"></v-select>
              </v-expansion-panel-content>
            </v-expansion-panel>     
            <!-- From Date & To Date -->
            <v-expansion-panel v-if="cboDivCd !== '1'">
              <v-expansion-panel-header>Check Date: {{ frmDate }} ~ {{ toDate }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- align="center" giúp căn giữa các ô theo chiều cao (vertical alignment) -->
                <v-row dense class="mx-0 mt-5" align="center">                  
                  <!-- Ép cố định chiếm 6/12 cột trên mọi kích thước màn hình -->
                  <v-col cols="6" class="px-1">
                    <div class="xy-center">
                      <div class="w-100" style="width: 100%;">
                        <v-menu ref="frmDate" :close-on-content-click="false" :return-value.sync="frmDate" offset-y min-width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="frmDate" label="From Date" readonly v-bind="attrs" v-on="on" hide-details outlined dense />
                          </template>
                          <v-date-picker v-model="frmDate" no-title scrollable>
                            <v-spacer />
                            <v-btn text @click="$refs.frmDate.isActive = false">Cancel</v-btn>
                            <v-btn text @click="$refs.frmDate.save(frmDate)">OK</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                  </v-col>

                  <!-- Ép cố định chiếm 6/12 cột trên mọi kích thước màn hình -->
                  <v-col cols="6" class="px-1">
                    <div class="xy-center">
                      <div class="w-100" style="width: 100%;">
                        <v-menu ref="toDate" :close-on-content-click="false" :return-value.sync="toDate" offset-y min-width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="toDate" label="To Date" readonly v-bind="attrs" v-on="on" hide-details outlined dense />
                          </template>
                          <v-date-picker v-model="toDate" no-title scrollable>
                            <v-spacer />
                            <v-btn text @click="$refs.toDate.isActive = false">Cancel</v-btn>
                            <v-btn text @click="$refs.toDate.save(toDate)">OK</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                  </v-col>

                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel> 
          </v-expansion-panels>          
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- End of search condition area -->
      <v-divider></v-divider>
      <!-- List information -->
      <!-- Start search result area -->
      <v-expansion-panel>
        <v-expansion-panel-header class="tit-lev1">
          Result: {{ listSize === 0?'No Data!': listSize }}
          <v-spacer />
          <v-btn  v-if="writeYn" small depressed color="primary" max-width="60px" @click.native.stop="btnAdd"> <span class="caption ">Add</span> </v-btn>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <v-text-field
            class="mt-2 mx-3"
            label="Filter"
            prepend-inner-icon="mdi-magnify"
            outlined
            clearable
            clear-icon="mdi-close-circle-outline"
            v-model="txtFilter"
            hide-details
            small
          />          
          <v-list class="px-0 py-0" nav dense>
            <v-list-item-group>
              <v-divider />              
              <div style="height: calc(100vh - 270px); overflow-y: auto; -webkit-overflow-scrolling: touch;">                
                <div v-for="(item, index) in filteredItems" :key="index">                  
                  <v-list-item 
                    class="px-3 mx-0 py-2" 
                    style="border-bottom: 1px solid #e0e0e0; min-height: unset; display: block;" 
                    @click="listItemClick(item)"
                  >
                    <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">                      
                      <tr>                  
                        <td style="width: 140px; padding: 6px 0;">
                          <v-chip color="green" dark small>{{ item.id }}</v-chip>
                        </td>
                        <td style="text-align: right; padding: 6px 0;">          
                          <v-btn 
                            v-if="writeYn" 
                            small 
                            depressed 
                            color="error" 
                            max-width="60px" 
                            @click.native.stop="btnDelete(item)"
                          >
                            <span class="caption">Delete</span>
                          </v-btn>
                        </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 140px; font-weight: bold; padding: 4px 0; vertical-align: top;">Ship No:</td>
                        <td style="word-break: break-all; padding: 4px 0;">{{ item.shipNo }}</td>
                      </tr>                  
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Check Date:</td>
                        <td style="padding: 4px 0;">{{ item.chkDte }}</td>
                      </tr>  
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Area:</td>
                        <td style="word-break: break-all; padding: 4px 0;">{{ getNameByCode(item.areaCd, 'listArea') }}</td>
                      </tr>  
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Department:</td>
                        <td style="word-break: break-all; padding: 4px 0;">{{ getNameByCode(item.deptCd, 'deptList') }}</td>
                      </tr> 
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Work group:</td>
                        <td style="word-break: break-all; padding: 4px 0;">{{ getNameByCode(item.respCd, 'respList') }}</td>
                      </tr> 
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">QM Part:</td>
                        <td style="padding: 4px 0;">{{ item.qmPart === 'M' ? 'Outfitting' : 'Painting' }}</td>
                      </tr>  
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Check Point:</td>
                        <td style="word-break: break-all; padding: 4px 0;">{{ getNameByCode(item.chkPntCd, 'listChkPoint') }}</td>
                      </tr>  
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Description:</td>
                        <td style="word-break: break-all; padding: 4px 0;">{{ item.descZone }}</td>
                      </tr>
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Countermeasure:</td>
                        <td style="word-break: break-all; padding: 4px 0;">{{ item.rmk }}</td>
                      </tr> 
                      <tr>                  
                        <td style="font-weight: bold; padding: 4px 0; vertical-align: top;">Repair Status:</td>
                        <td style="padding: 4px 0;">{{ item.zoneSta === 'C' ? 'Completed' : 'Not yet' }}</td>
                      </tr> 
                      <!-- BEFORE PHOTO -->
                      <tr>
                        <td style="font-weight: bold; padding: 6px 0; vertical-align: middle;">Before Photo</td>
                        <td style="padding: 6px 0;">
                          <!-- Thay đổi justify-content thành flex-end và thêm gap để tạo khoảng cách giữa 2 nút -->
                          <div style="display: flex; align-items: center; justify-content: flex-end; gap: 12px; width: 100%;">
                            <div>
                              <div v-if="item.__created__"></div>
                              <div v-else-if="item.bfileYn === 'N'">
                                <v-btn small text class="px-0 py-0 blue--text" @click.stop="triggerUpload(item, 'BF')">
                                  Open <v-icon small color="blue" class="ml-1">mdi-folder-open</v-icon>
                                </v-btn>
                              </div>
                              <div v-else-if="item.bfileYn !== 'N'">
                                <v-btn small text class="px-0 py-0 blue--text" @click.stop="openFile(item, 'BF')">
                                  Preview <v-icon small color="blue" class="ml-1">mdi-magnify</v-icon>
                                </v-btn>
                              </div>
                            </div>
                            <div>
                              <div v-if="!item.__created__ && item.bfileYn !== 'N'">
                                <v-btn small text class="px-0 py-0 red--text" @click.stop="deleteFile(item, 'BF')">
                                  Delete <v-icon small color="red" class="ml-1">mdi-delete</v-icon>
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr> 

                      <!-- AFTER PHOTO -->
                      <tr>
                        <td style="font-weight: bold; padding: 6px 0; vertical-align: middle;">After Photo</td>
                        <td style="padding: 6px 0;">
                          <!-- Thay đổi justify-content thành flex-end và thêm gap để tạo khoảng cách giữa 2 nút -->
                          <div style="display: flex; align-items: center; justify-content: flex-end; gap: 12px; width: 100%;">
                            <div>
                              <div v-if="item.__created__"></div>
                              <div v-else-if="item.afileYn === 'N'">
                                <v-btn small text class="px-0 py-0 blue--text" @click.stop="triggerUpload(item, 'AF')">
                                  Open <v-icon small color="blue" class="ml-1">mdi-folder-open</v-icon>
                                </v-btn>
                              </div>
                              <div v-else-if="item.afileYn !== 'N'">
                                <v-btn small text class="px-0 py-0 blue--text" @click.stop="openFile(item, 'AF')">
                                  Preview <v-icon small color="blue" class="ml-1">mdi-magnify</v-icon>
                                </v-btn>
                              </div>
                            </div>
                            <div>
                              <div v-if="!item.__created__ && item.afileYn !== 'N'">
                                <v-btn small text class="px-0 py-0 red--text" @click.stop="deleteFile(item, 'AF')">
                                  Delete <v-icon small color="red" class="ml-1">mdi-delete</v-icon>
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr> 
                    </table>
                  </v-list-item>                  
                </div>
              </div>              
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>      
      <!-- End of search result area -->
      <!-- Start detailed dialog -->
      <!-- <v-dialog fullscreen persistent v-model="showDetail" > -->
      <v-dialog fullscreen persistent v-model="showDetail" scrollable>
        <!-- <v-card > -->
        <v-card style="height: 100dvh; display: flex; flex-direction: column;">
          <v-toolbar height="55px" class="app_bar_bg" color="primary" dark style="flex-shrink: 0;">
            <v-chip color="green" dark small >{{ itemDetail.id }}</v-chip>
            <v-spacer />
            <v-btn icon>
              <v-icon @click="showDetail = false">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!--  <v-sheet style="overflow-x: auto; overflow-y: auto" max-height="calc(100vh - 55px)"> -->
          <v-sheet style="flex: 1 1 auto; overflow-y: auto; overflow-x: auto;">
            <div class="pt-3 mr-3" style="display: flex; justify-content: end;">
              <v-btn  v-if="writeYn" small color="primary" class=" mr-2" @click="btnSave">
                Save
              </v-btn>
            </div>
            <v-simple-table style="white-space: normal; word-wrap: break-word; word-break: break-all;">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="width: 150px">
                      <strong>Ship No</strong>
                    </td>
                    <td>
                      <v-select
                        v-model="itemDetail.shipNo"
                        :items="listShip"
                        :item-value="`shipNo`"
                        :item-text="`shipNo`"
                        hide-details
                        dense
                        :readonly=true
                      />
                    </td>
                  </tr>               
                  <tr>
                    <td style="width: 110px">
                      <strong>Check Date</strong>
                    </td>
                    <td>
                      <div style="display: flex; justify-content: start;">
                        <v-dialog ref="dialog_chkdte" v-model="modal_chkdate" :return-value.sync="itemDetail.chkDte" persistent width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="itemDetail.chkDte" label="" :readonly="!isNew" v-bind="attrs" v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="itemDetail.chkDte" scrollable>
                            <v-btn text color="primary" @click="modal_chkdate = false">
                              Cancel
                            </v-btn>
                            <v-btn text color="primary" @click="$refs.dialog_chkdte.save(itemDetail.chkDte)">
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </div>
                    </td>
                  </tr>  
                  <tr>
                    <td style="width: 100px">
                      <strong>Area</strong>
                    </td>
                    <td>
                      <v-select
                        v-model="itemDetail.areaCd"
                        :items="listArea"
                        :item-value="`code`"
                        :item-text="`name`"
                        hide-details
                        dense
                        :readonly="!isNew"
                      />
                    </td>
                  </tr>                   
                  <tr>
                    <td style="width: 100px">
                      <strong>Department</strong>
                    </td>
                    <td>
                      <v-select
                        v-model="itemDetail.deptCd"
                        :items="deptList"
                        :item-value="`code`"
                        :item-text="`name`"
                        hide-details
                        dense
                        :readonly="!isNew"
                      />
                    </td>
                  </tr>     
                  <tr>
                    <td style="width: 100px">
                      <strong>Work Group</strong>
                    </td>
                    <td>
                      <v-select
                        v-model="itemDetail.respCd"
                        :items="getFilteredList('respList', 'deptCd')"
                        :item-value="`code`"
                        :item-text="`name`"
                        hide-details
                        dense
                        :readonly="!isNew"
                      />
                    </td>
                  </tr>   
                  <tr>
                    <td style="width: 100px">
                      <strong>QM Part</strong>
                    </td>
                    <td>
                      <v-select
                        v-model="itemDetail.qmPart"
                        :items="listQmPart"
                        :item-value="`code`"
                        :item-text="`name`"
                        hide-details
                        dense
                        :readonly="!isNew"
                      />
                    </td>
                  </tr> 
                  <tr>
                    <td style="width: 100px">
                      <strong>Check Point</strong>
                    </td>
                    <td>
                      <v-select
                        v-model="itemDetail.chkPntCd"
                        :items="getFilteredList('listChkPoint', 'qmPart', { parentKeyInList: 'qmPart' })"
                        :item-value="`code`"
                        :item-text="`name`"
                        hide-details
                        dense
                        :readonly="!isNew"
                      />
                    </td>
                  </tr>  
                  <tr>
                    <td style="width: 100px">
                      <strong>Description</strong>
                    </td>
                    <td>
                      <!-- Thay thế v-text-field bằng v-textarea kết hợp auto-grow -->
                      <v-textarea 
                        v-model.trim="itemDetail.descZone" 
                        hide-details 
                        dense 
                        auto-grow 
                        rows="1"
                      /> 
                    </td>
                  </tr>
                  <!-- <tr>
                    <td style="width: 100px">
                      <strong>Description</strong>
                    </td>
                    <td>
                      <v-text-field v-model.trim="itemDetail.descZone" hide-details dense /> 
                    </td>
                  </tr>     -->
                  <tr>
                    <td style="width: 100px">
                      <strong>Countermeasure</strong>
                    </td>
                    <td>
                      <v-text-field v-model.trim="itemDetail.rmk" hide-details dense /> 
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 110px">
                      <strong>Completed Date</strong>
                    </td>
                    <td>
                      <div style="display: flex; justify-content: start;">
                        <v-dialog ref="dialog_findte" v-model="modal_findate" :return-value.sync="itemDetail.finDte" persistent width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="itemDetail.finDte" label=" " :readonly="!isNew" v-bind="attrs" v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="itemDetail.finDte" scrollable>
                            <v-btn text color="primary" @click="modal_findate = false">
                              Cancel
                            </v-btn>
                            <v-btn text color="primary" @click="$refs.dialog_findte.save(itemDetail.finDte)">
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </div>
                    </td>
                  </tr>
                  <!-- Before Photo -->
                  <tr>
                    <td style="width: 100px">
                      <strong>Before Photo</strong>
                    </td>
                    <td>
                      <!-- Thay đổi thành justify-content: end để dồn toàn bộ nội dung về bên phải -->
                      <div style="display: flex; justify-content: end; width: 100%;">
                        
                        <!-- Cụm nút Open / Preview -->
                        <div class="mr-2"> <!-- Thêm margin-right để tạo khoảng cách nhỏ với nút Delete -->
                          <div v-if="itemDetail.__created__"></div>
                          <div v-else-if="itemDetail.bfileYn === 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="triggerUpload(itemDetail, 'BF')" >
                              Open
                              <v-icon color="blue">$folder</v-icon>
                            </v-btn>
                          </div>
                          <div v-else-if="itemDetail.bfileYn !== 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(itemDetail, 'BF')" >
                              Preview
                              <v-icon color="blue">$search</v-icon>
                            </v-btn>
                          </div>
                        </div>

                        <!-- ĐÃ XÓA V-SPACER TẠI ĐÂY -->

                        <!-- Cụm nút Delete -->
                        <div>
                          <div v-if="!itemDetail.__created__ && itemDetail.bfileYn !== 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="deleteFile(itemDetail, 'BF')" >
                              Delete
                              <v-icon color="blue">$delete</v-icon>
                            </v-btn>
                          </div>
                        </div>

                      </div>                      
                    </td>
                  </tr>   

                  <!-- After Photo -->
                  <tr>
                    <td style="width: 100px">
                      <strong>After Photo</strong>
                    </td>
                    <td>
                      <!-- Thay đổi thành justify-content: end để dồn toàn bộ nội dung về bên phải -->
                      <div style="display: flex; justify-content: end; width: 100%;">
                        
                        <!-- Cụm nút Open / Preview -->
                        <div class="mr-2"> <!-- Thêm margin-right để tạo khoảng cách nhỏ với nút Delete -->
                          <div v-if="itemDetail.__created__"></div>
                          <div v-else-if="itemDetail.afileYn === 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="triggerUpload(itemDetail, 'AF')" >
                              Open
                              <v-icon color="blue">$folder</v-icon>
                            </v-btn>
                          </div>
                          <div v-else-if="itemDetail.afileYn !== 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(itemDetail, 'AF')" >
                              Preview
                              <v-icon color="blue">$search</v-icon>
                            </v-btn>
                          </div>
                        </div>

                        <!-- ĐÃ XÓA V-SPACER TẠI ĐÂY -->

                        <!-- Cụm nút Delete -->
                        <div>
                          <div v-if="!itemDetail.__created__ && itemDetail.afileYn !== 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="deleteFile(itemDetail, 'AF')" >
                              Delete
                              <v-icon color="blue">$delete</v-icon>
                            </v-btn>
                          </div>
                        </div>

                      </div>                      
                    </td>
                  </tr>               
                  <tr>
                    <td style="width: 100px">
                      <strong>Repair Staus</strong>
                    </td>
                    <td>
                      <v-select
                        v-model="itemDetail.zoneSta"
                        :items="listZoneSta"
                        :item-value="`code`"
                        :item-text="`name`"
                        hide-details
                        dense
                        :readonly="!isNew"
                      />
                    </td>
                  </tr>  
                </tbody>
              </template>
            </v-simple-table>
            <!-- MẸO PHỤ: Thêm một khoảng trống padding phía dưới cùng để không bao giờ bị dính mép -->
            <div style="height: 20px;"></div>
            <input type="file" ref="fileInputHidden" style="display: none" accept="image/*" @change="onFileSelected" />
          </v-sheet> 
        </v-card>
      </v-dialog>    
      <!-- End of detailed dialog -->     
      <!-- Scroll To Top -->
      <v-btn small v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-expansion-panels>
    <v-dialog v-model="isPreviewPopupOpen" max-width="800px" content-class="elevation-0" attch>
      <v-card flat color="transparent" class="text-right">
        <v-btn icon dark @click="closePreviewPopup" class="mb-2">
          <v-icon large>mdi-close-circle</v-icon>
        </v-btn>
        
        <v-card-text class="pa-0">          
          <embed 
            v-if="previewFileType === 'pdf'" 
            :src="previewFileData" 
            type="application/pdf" 
            style="width: 100%; height: 70vh; background-color: white;" 
            class="rounded-lg"
          />

          <v-img
            v-else
            :src="previewFileData"
            width="100%"
            contain
            class="rounded-lg shadow-lg"
            style="background-color: white;"
          >
            </v-img>
        </v-card-text>
        
        <div class="text-center mt-2">
          <v-btn color="white" text @click="closePreviewPopup">Close Escape</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>  
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiChevronUp, mdiFolder, mdiEye } from '@mdi/js'
import baseview from '@/components/base/baseview.vue' 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' 
import notify from 'devextreme/ui/notify' 
import moment from 'moment'
import EventBus from '@/components/event-bus'
import { ftpDownloadViewer } from "@/api/view/tqm/common/common.js"

// Import chính xác các hàm quản lý API phân hệ ZONE của bản PC
import { 
  getCheckPoint, 
  getArea, 
  getDivision, 
  searchZoneList, 
  saveZone, 
  deleteZone,
  uploadZoneFileFtp,  
  deleteZoneFile      
} from '@/api/view/tqm/80/v80d3010.js'

import { 
  getShipList, 
  getDeptList,
  getRespList
} from '@/api/view/tqm/80/v80comm.js'        

export default {
  name: "v80d3010m",
  mixins: [baseview, BaseDataGrid],
  
  data: () => ({
    openedPanel: 0,
    cOpenedPanel: -1,
    txtFilter: '',
    fab: false,

    // Quản lý trạng thái Date Picker lơ lửng trên Mobile
    modal_chkdate: false,
    modal_findate: false,

    // Dữ liệu ràng buộc bộ lọc tìm kiếm
    cboDivCd: '1',
    frmDate: moment().subtract(1, 'months').format('YYYY-MM-DD'), 
    toDate: moment().format('YYYY-MM-DD'),
    cboShipNo: '',

    // Hệ thống mảng danh mục Combo Box
    listDivCd: [],
    listShip: [],
    listArea: [],
    deptList: [],
    respList: [],
    listChkPoint: [],
    listQmPart: [
      { code: 'M', name: 'Outfitting' },
      { code: 'P', name: 'Painting' },
    ],
    listZoneSta: [
      { code: 'C', name: 'Completed' },
      { code: 'N', name: 'Not yet' },
    ],

    // Danh sách dữ liệu hiển thị chính
    gridMainList: [],
    listSize: 0,

    // Trạng thái Form chi tiết
    showDetail: false,
    itemDetail: {},
    oriItem: {},
    isNew: false,

    // Tham số trung gian phục vụ Upload tệp lên FTP
    currentUploadRowData: null, 
    currentUploadDiv: '', // 'BF' (Before) hoặc 'AF' (After)

    // Trạng thái cấu trúc Popup Preview xem ảnh trực tiếp
    isPreviewPopupOpen: false,
    previewFileData: '',
    previewFileType: '',
    previewFileName: '',

    writeYn: 'N'
  }),

  computed: {
      filteredItems() {
      if (!this.gridMainList || this.gridMainList.length === 0) return [];
      if (!this.txtFilter) return this.gridMainList;
      
      const keyword = this.txtFilter.toLowerCase().trim();
      
      return this.gridMainList.filter(item => {
        // Ép toàn bộ các Mã thành Tên đầy đủ bằng hàm tổng quát vừa viết
        const areaName = this.getNameByCode(item.areaCd, 'listArea').toLowerCase();
        const deptName = this.getNameByCode(item.deptCd, 'deptList').toLowerCase();
        const respName = this.getNameByCode(item.respCd, 'respList').toLowerCase();
        const chkPntName = this.getNameByCode(item.chkPntCd, 'listChkPoint').toLowerCase();
        
        // Các chuỗi dữ liệu thô khác
        const shipNo = (item.shipNo || '').toLowerCase();
        const chkDte = (item.chkDte || '').toLowerCase();
        const desc = (item.descZone || '').toLowerCase();
        const rmk = (item.rmk || '').toLowerCase();
        const id = String(item.id || '').toLowerCase();
        
        const qmPartText = item.qmPart === 'M' ? 'outfitting' : 'painting';
        const repairStatusText = item.zoneSta === 'C' ? 'completed' : 'not yet';
        
        // Tìm kiếm toàn diện trên mọi trường dữ liệu hiển thị
        return areaName.includes(keyword) ||
              deptName.includes(keyword) || 
              respName.includes(keyword) || 
              chkPntName.includes(keyword) ||
              shipNo.includes(keyword)   ||
              chkDte.includes(keyword)   ||
              desc.includes(keyword)     || 
              rmk.includes(keyword)      ||
              id.includes(keyword)       ||
              qmPartText.includes(keyword) ||
              repairStatusText.includes(keyword);
      });
    },
    panelHeaderText() {
      const baseText = `Div: [${this.division}]- Ship: [${this.ship}]`;
      
      // Nếu chọn '1' (All) thì chỉ trả về phần text gốc, ngược lại thì cộng thêm chuỗi ngày
      return this.cboDivCd === '1' ? baseText : `${baseText} - [${this.frmDate} ~ ${this.toDate}]`;
    },
    // filteredItems() {
    //   return this.$gUtil.executeFilter(this.gridMainList, this.txtFilter)
    // },
    division() {
      const items = this.listDivCd.filter(item => item.code && item.code === this.cboDivCd)
      return items.length > 0 ? items[0].name : 'ALL'
    },
    ship: function() {
         const items = this.listShip.filter(item => item.shipNo && item.shipNo === this.cboShipNo);         
         return items.length > 0 ? items[0].shipNo : "ALL";
    },
    // === BỔ SUNG THÊM COMPUTED NÀY ===
    filteredRespItems() {
      // Nếu chưa chọn Department, trả về toàn bộ hoặc mảng rỗng tùy theo thiết kế hệ thống của bạn (ở đây trả về rỗng để bắt buộc chọn Dept trước)
      if (!this.itemDetail || !this.itemDetail.deptCd) {
        return []; 
      }
      // Lọc các Work Group có deptCd trùng với deptCd đang chọn trong itemDetail
      return this.respList.filter(item => item.deptCd === this.itemDetail.deptCd);
    },
  },

  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnSearch();
    });
  },

  mounted() {
    this.writeYn = this.$gUtil.getWriteYn()
    this.setCombo()
  },

  beforeDestroy() {
    EventBus.$off(this.$options.name + "_search");
  },

  methods: {     
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    },
    btnSearch() {
      this.gridMainList = []        
      this.doSearchMainList()          
    },

    // Nạp nguồn dữ liệu cho toàn bộ danh mục Combobox
    async setCombo() {
      let params = { shipNo: '' }     

      const ckeckPoint = async () => {
        await getCheckPoint(params).then(result => {
          this.listChkPoint = [];
          (result.list || []).forEach(item => {
            this.listChkPoint.push({
              name: item.name,
              code: item.code,
              qmPart: item.qmPart || ''
            })
          })
        })
      }
      const ship = async () => {
        await getShipList(params).then(result => {
          // console.log("####res.list", res.list);
          this.listShip = result.list
          // this.listRShip = JSON.parse(JSON.stringify(result.list));
          this.listShip.splice(0, 0, { shipNo: "ALL", shipDesc: "ALL" });
        })
      }
      const division = async () => {
        await getDivision(params).then(result => {
          this.listDivCd = result.list || [];
        })
      }
      const dept = async () => {
        await getDeptList(params).then(result => {
          this.deptList = [];
          (result.list || []).forEach(item => {
            this.deptList.push({
              name: item.deptCd + ': '+ item.deptNm,
              code: item.deptCd
            })
          })
        })
      }
      const resp = async () => {
        await getRespList({ deptCd: '' }).then(result => {
          this.respList = [];
          (result.list || []).forEach(item => {
            this.respList.push({
              name: item.respCd + ': '+ item.respNm,
              code: item.respCd,
              deptCd: item.deptCd || ''
            })
          })
        })
      }
      const area = async () => {
        await getArea(params).then(result => {
          this.listArea = [];
          (result.list || []).forEach(item => {
            this.listArea.push({ name: item.name, code: item.code })
          })
        })
      }

      this.$qLoading.show()
      await Promise.all([ship(), division(), dept(), resp(), area(), ckeckPoint()])
        .catch(ex => { console.error("Combo load error:", ex) })
        .finally(() => { this.$qLoading.hide() })
    },
    // HÀM TỔNG QUÁT: Lọc danh sách con dựa theo mã của danh mục cha
    getFilteredList(childListName, parentKeyInDetail, childConfig = { parentKeyInList: 'deptCd' }) {
      // 1. Kiểm tra nếu thực thể dữ liệu chi tiết chưa khởi tạo hoặc chưa chọn danh mục cha
      if (!this.itemDetail || !this.itemDetail[parentKeyInDetail]) {
        return []; // Trả về mảng rỗng để bắt buộc người dùng chọn danh mục cha trước
      }

      // 2. Lấy mảng dữ liệu con từ instance (this) dựa vào tên mảng truyền vào
      const childList = this[childListName];
      if (!childList || !Array.isArray(childList)) {
        return [];
      }

      // 3. Lấy trường khóa cha cấu hình trong mảng con (mặc định nếu không truyền là 'deptCd')
      const matchKey = childConfig.parentKeyInList || 'deptCd';

      // 4. Thực hiện lọc danh sách con
      return childList.filter(item => item[matchKey] === this.itemDetail[parentKeyInDetail]);
    },
    // HÀM TỔNG QUÁT: Ánh xạ Mã (Code) thành Tên (Name) dựa trên danh sách động
    getNameByCode(codeValue, listName, fallbackProp = '') {
      if (codeValue === undefined || codeValue === null || codeValue === '') return '';      
      // Lấy mảng dữ liệu từ instance (this) dựa vào tên mảng truyền vào
      const targetList = this[listName];
      if (!targetList || !Array.isArray(targetList)) return codeValue;      
      // Tìm phần tử có code trùng khớp
      const foundItem = targetList.find(x => x.code === codeValue);      
      // Nếu tìm thấy trả về thuộc tính .name, không thấy trả về chính mã gốc (hoặc trường dự phòng)
      return foundItem ? foundItem.name : (fallbackProp || codeValue);
    },
    
    // 1. Ánh xạ Mã phòng ban (Department Code) thành Tên hiển thị
    getDeptName(deptCd) {
      if (!deptCd) return '';
      const dept = this.deptList.find(d => d.code === deptCd);
      return dept ? dept.name : deptCd; // Nếu tìm thấy thì trả về "D0: Outfitting 2", không thấy thì giữ nguyên Code
    },
    // Hàm gọi API tìm kiếm danh sách chính
    async doSearchMainList() {
      // if (!this.cboShipNo) {
      //   this.vToastify('Please, select Ship No.', 'warn')
      //   return
      // }

      try {
        this.openLoading('Searching...')
        let params = {
          divCd: this.cboDivCd,
          shipNo: this.cboShipNo == "ALL" ? '%': this.cboShipNo,
          frmDate: this.frmDate ? this.frmDate : '',
          toDate: this.toDate ? this.toDate : ''
        }
        // console.log('===>params doSearchMainList', params);
        
        await searchZoneList(params).then(res => {
          if (res && res.list && res.list.length > 0) {
            this.gridMainList = res.list
            this.listSize = res.list.length
            this.openedPanel = 1 
          } else {
            this.gridMainList = []
            this.listSize = 0
            notify('No Data Found', 'info', 3000)
          }
        })
      } finally {
        this.endLoading()
      }
    },

    // Khởi tạo thực thể mới khi ấn nút Add
    btnAdd() {
      if (!this.cboShipNo) {
        this.vToastify('Please, select Ship No to Add.', 'warn')
        return
      }
      this.isNew = true
      this.oriItem = {}
      this.itemDetail = {
        shipNo: this.cboShipNo,
        chkDte: moment().format('YYYY-MM-DD'),
        areaCd: '',
        deptCd: '',
        respCd: '',
        qmPart: '',
        chkPntCd: '',
        descZone: '',
        rmk: '',
        finDte: '',
        bfileYn: 'N',
        fileNmBf: '',
        afileYn: 'N', // Bổ sung quản lý cờ file AF mới thêm
        fileNmAf: '', // Tên file thực tế ảnh AF mới thêm
        zoneSta: 'N',
        __created__: true,
        __modified__: false
      }
      this.showDetail = true
    },

    // Hàm Lưu dữ liệu (Map đầy đủ các trường Before và After Photo lên Backend)
    async btnSave() {
      if (!this.itemDetail.shipNo || !this.itemDetail.deptCd || !this.itemDetail.respCd) {
        this.vToastify('Please fill in all mandatory fields (*)', 'warn')
        return
      }

      const rowPayload = {
        id: this.itemDetail.id || 1 + '',
        shipNo: this.itemDetail.shipNo,
        zoneSeq: this.itemDetail.zoneSeq || null,
        chkDte: this.itemDetail.chkDte ? this.itemDetail.chkDte.replace(/-/g, '') : '',
        areaCd: this.itemDetail.areaCd || '',
        deptCd: this.itemDetail.deptCd,
        respCd: this.itemDetail.respCd,
        qmPart: this.itemDetail.qmPart,
        chkPntCd: this.itemDetail.chkPntCd,
        descZone: this.itemDetail.descZone || '',
        rmk: this.itemDetail.rmk || '',
        finDte: this.itemDetail.finDte ? this.itemDetail.finDte.replace(/-/g, '') : '',
        zoneSta: this.itemDetail.zoneSta || 'N',
        fileNmBf: this.itemDetail.fileNmBf || '',
        bfileYn: this.itemDetail.bfileYn || 'N',
        fileNmAf: this.itemDetail.fileNmAf || '', // Map thêm trường lưu DB cho ảnh sau xử lý
        afileYn: this.itemDetail.afileYn || 'N',
        userId: this.$store.state.user.userId,
        __created__: this.isNew,
        __modified__: !this.isNew
      }

      try {
        this.openLoading('Saving Data...')
        // Gọi API lưu dữ liệu
        const response = await saveZone([rowPayload]);
        
        notify('Saved Successfully', 'success', 3000);

        // 1. Chuyển đổi trạng thái Mode của màn hình (Giữ nguyên code cũ)
        this.isNew = false; 

        // 2. CẬP NHẬT CỜ TRÊN CHÍNH itemDetail ĐỂ TEMPLATE ẨN/HIỆN NÚT OPEN
        // Ép cờ __created__ về false để Vue bỏ qua div trống và nhảy xuống nhánh render nút Open
        this.$set(this.itemDetail, '__created__', false);
        this.$set(this.itemDetail, '__modified__', true);

        // 3. Cập nhật khóa chính định danh trả về từ Backend (Giữ nguyên code tối ưu hôm trước)
        let resData = response?.data || response;
        let activeZoneSeq = null;
        let activeId = null;

        if (resData && resData.list && resData.list.length > 0) {
          const savedItem = resData.list[0];
          activeZoneSeq = savedItem.zoneSeq;
          activeId = savedItem.id;
        } else if (resData?.zoneSeq) {
          activeZoneSeq = resData.zoneSeq;
          activeId = resData.id;
        }

        if (activeZoneSeq) {
          this.$set(this.itemDetail, 'zoneSeq', activeZoneSeq);
          if (activeId) this.$set(this.itemDetail, 'id', activeId);
          
          // Gán dòng hiện hành để sẵn sàng upload file
          this.currentUploadRowData = this.itemDetail;
        }

        // 4. Tải lại danh sách ngầm phía sau (Giữ nguyên)
        if (typeof this.doSearchMainList === 'function') {
          this.doSearchMainList();
        }

      } catch (err) {
        this.vToastify(err.message || 'Save failed', 'warn')
      } finally {
        this.endLoading()
      }
    },

    // Hàm Xóa dòng (Đã tối ưu hóa quét dọn dẹp đồng thời cả file BF và file AF trên FTP)
    async btnDelete(item) {
      this.vToastifyPrompt(
        'Do you want to delete the selected item?',
        'info',
        async current => {
          this.openLoading('Processing delete...');
          try {
            // Loại bỏ file đính kèm Before nếu có
            if (item.fileNmBf && item.bfileYn !== 'N') {
              try {
                await deleteZoneFile({ shipNo: item.shipNo, zoneSeq: item.zoneSeq, fileType: 'BF', fileName: item.fileNmBf });
              } catch (e) {}
            }
            // Loại bỏ file đính kèm After nếu có
            if (item.fileNmAf && item.afileYn !== 'N') {
              try {
                await deleteZoneFile({ shipNo: item.shipNo, zoneSeq: item.zoneSeq, fileType: 'AF', fileName: item.fileNmAf });
              } catch (e) {}
            }

            // Gọi lệnh xóa bản ghi DB chính thức
            await deleteZone([item]).then(() => {
              this.vToastify('Delete successful...', 'success');
              this.btnSearch();
            }).catch(dbErr => {
              this.vToastify(dbErr.message || 'DB Delete failed', 'warn');
            });

          } catch (error) {
            console.error("Delete Flow Error:", error);
            this.vToastify(error.message || 'Delete failed', 'warn');
          } finally {
            this.endLoading();
          }
        },
        null,
        true
      );
    },

    listItemClick(item) {
      this.isNew = true
      this.oriItem = item
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.showDetail = true
    },

    // ==========================================
    // KHỐI QUẢN LÝ TIẾN TRÌNH FILE FTP (BF & AF)
    // ==========================================
    triggerUpload(rowData, divType) {
      this.currentUploadRowData = rowData;
      this.currentUploadDiv = divType; // Tiếp nhận động loại ảnh 'BF' hoặc 'AF' từ Template đẩy lên
      this.$refs.fileInputHidden.click();
    },

    async onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Chuẩn bị FormData đóng gói để gửi lên API Backend
      const formData = new FormData();
      formData.append("file", file);
      formData.append("shipNo", this.currentUploadRowData.shipNo);
      formData.append("zoneSeq", this.currentUploadRowData.zoneSeq); // Đảm bảo dòng đã có khóa chính DB
      formData.append("fileType", this.currentUploadDiv); // Truyền 'BF' hoặc 'AF'

      try {
        this.openLoading('Uploading file to FTP...');
        
        // Gọi API upload file FTP lên Backend Java
        const response = await uploadZoneFileFtp(formData);
        // console.log('response', response);
        
        // === ĐOẠN CẬP NHẬT MỚI CHUẨN XÁC ===
        if (response) {
          let isSuccess = false;
          let serverMessage = '';

          // 1. Phân tích dữ liệu phản hồi (Ép kiểu từ chuỗi JSON nếu có)
          let resData = response.data;
          if (typeof resData === 'string') {
            try {
              // Nếu Backend trả về chuỗi dạng JSON object, tiến hành chuyển đổi sang Object JS
              resData = JSON.parse(resData);
            } catch (e) {
              // Nếu là chuỗi text đường dẫn thô thông thường, giữ nguyên
            }
          }

          // 2. KIỂM TRA ĐIỀU KIỆN THÀNH CÔNG ĐA TẦNG
          if (
            response.status === 200 || 
            response.status === 'SUCCESS' ||
            resData?.status === 'SUCCESS' ||
            (typeof response.data === 'string' && response.data.includes('/attachfile/')) ||
            (resData?.data && String(resData.data).includes('/attachfile/'))
          ) {
            isSuccess = true;
          } else {
            serverMessage = resData?.message || resData?.msg || '';
          }

          // 3. HIỂN THỊ THÔNG BÁO VÀ RELOAD GRID DỮ LIỆU
          if (isSuccess) {
            // Bắn thông báo thành công xanh mượt chuẩn hệ thống
            this.vToastify(this.$t('Upload file successfully...'), 'success');

            // === BỔ SUNG ĐỂ CẬP NHẬT GIAO DIỆN FORM ĐANG MỞ (UX) ===
            // Lấy tên file trả về từ Server (nếu có), hoặc dùng tạm file.name để kích hoạt nút Preview lập tức
            const finalFileName = resData?.fileName || file.name; 
            if (this.currentUploadDiv === 'BF') {
              this.itemDetail.bfileYn = 'Y';
              this.itemDetail.fileNmBf = finalFileName;
            } else {
              this.itemDetail.afileYn = 'Y';
              this.itemDetail.fileNmAf = finalFileName;
            }
            // Reload lại Grid danh sách phía sau nền
            if (typeof this.doSearchMainList === 'function') {
              this.doSearchMainList();
            } else if (typeof this.searchList === 'function') {
              this.searchList();
            }
          } else {
            // Hiển thị thông báo lỗi chi tiết từ server nếu có
            this.vToastify(serverMessage || 'Upload failed from server', 'warn');
          }
        }

      } catch (error) {
        console.error("Upload error log:", error);
        // === SỬA LỖI KHÔNG GỌI BIẾN RESPONSE CHƯA ĐỊNH NGHĨA ===
        const errorMsg = error.response?.data?.message || error.message || 'Upload failed';
        this.vToastify(errorMsg, 'warn');
      } finally {
        event.target.value = ''; // Reset input để lần sau chọn lại file cũ không bị kẹt sự kiện
        this.endLoading();
      }
    },
    
    async openFile(item, divType) {
      // Xác định động tên file cần hiển thị dựa trên divType ('BF' hay 'AF')
      let fileName = (divType === 'BF') ? item.fileNmBf : item.fileNmAf;
      if (!fileName) return;

      try {
        this.openLoading('Loading file preview...');
        const filePath = 'attachfile/TQM/ZONE_FINAL/' + item.shipNo + '/' + fileName;
        const response = await ftpDownloadViewer(filePath, 'temp_file'); 
        const fileRes = response?.data || response; 

        if (fileRes && fileRes.body) {
          const ext = fileName.split('.').pop().toLowerCase();
          let dataType = `data:image/${ext};base64,`;
          if (ext === 'pdf') dataType = "data:application/pdf;base64,";

          this.previewFileData = dataType + fileRes.body;
          this.previewFileType = ext;
          this.previewFileName = fileName;
          this.isPreviewPopupOpen = true;
        } else {
          this.vToastify('Could not load file content.', 'warn');
        }
      } catch (error) {
        this.vToastify('Preview failed', 'warn');
      } finally {
        this.endLoading();
      }
    },

    async deleteFile(item, divType) {
      let targetFileName = (divType === 'BF') ? item.fileNmBf : item.fileNmAf;
      
      this.vToastifyPrompt(
        `Do you want to delete this photo file on FTP Server?`,
        'info',
        async current => {
          this.openLoading('Deleting file on FTP...');
          try {
            const response = await deleteZoneFile({
              shipNo: item.shipNo,
              zoneSeq: item.zoneSeq,
              fileType: divType,
              fileName: targetFileName
            });
            
            // Lấy dữ liệu data an toàn
            let resData = response?.data !== undefined ? response.data : response;
            
            // KIỂM TRA ĐIỀU KIỆN THÀNH CÔNG ĐA TẦNG (Bao quát cả Boolean true và chuỗi không phân biệt hoa thường)
            if (
              response?.status === 200 || 
              response?.status === 'SUCCESS' ||
              resData === true || 
              resData?.status === 'SUCCESS' ||
              resData?.status === 'success' ||
              (typeof resData === 'string' && resData.toUpperCase().includes('SUCCESS')) ||
              (resData?.message && resData.message.toUpperCase().includes('SUCCESS'))
            ) {
              
              this.vToastify('Deleted photo successfully!', 'success');
              
              // Trả trạng thái rỗng tương ứng về cho UI Dialog sau khi xóa vật lý thành công
              if (divType === 'BF') {
                this.$set(this.itemDetail, 'bfileYn', 'N');
                this.$set(this.itemDetail, 'fileNmBf', '');
              } else {
                this.$set(this.itemDetail, 'afileYn', 'N');
                this.$set(this.itemDetail, 'fileNmAf', '');
              }
              
              // Tải lại lưới danh sách nền
              if (typeof this.doSearchMainList === 'function') {
                this.doSearchMainList();
              } else if (typeof this.btnSearch === 'function') {
                this.btnSearch();
              }
              
            } else {
              // Hiển thị thông báo lỗi chi tiết từ server nếu có cấu trúc msg/message
              let serverMsg = resData?.message || resData?.msg || 'Delete file failed from server';
              this.vToastify(serverMsg, 'warn');
            }
          } catch (error) {
            console.error("Delete file error log:", error);
            this.vToastify(error.message || 'Delete failed', 'warn');
          } finally {
            this.endLoading();
          }
        },
        null,
        true
      );
    },    

    closePreviewPopup() {
      this.isPreviewPopupOpen = false;
      this.previewFileData = '';
      this.previewFileType = '';
      this.previewFileName = '';
    }
  }
};
</script>

<style scoped>
.preview-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex; justify-content: center; align-items: center;
  z-index: 9999 !important;
}
.preview-content {
  position: relative; width: 92%; max-width: 480px;
  background: white; border-radius: 8px; padding: 10px;
}
.preview-close-btn {
  position: absolute; 
  top: 8px;      /* Thụt vào trong góc */
  right: 8px;    /* Thụt vào trong góc */
  width: 28px; 
  height: 28px; 
  border-radius: 50%;
  z-index: 10;   /* Đảm bảo nằm trên ảnh */
  background: #e53935; 
  color: white; 
  border: none; 
  font-size: 18px;
  display: flex; 
  align-items: center; 
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
}
.preview-body {
  width: 100%; display: flex; justify-content: center;
}
.preview-img, .preview-iframe {
  max-width: 100%; max-height: 65vh; object-fit: contain;
}
.preview-footer {
  text-align: center; margin-top: 8px; font-size: 11px; color: #555;
  text-overflow: ellipsis; white-space: nowrap; overflow: hidden;
}
table td {
  padding: 6px 4px;
}
</style>